import { ca } from '@cian/analytics';

interface ITrackQRShowParams {
  label: 'modal_qr_code' | 'carousel_qr_code';
  offerId: number;
}

export const trackQRShow = ({ label, offerId }: ITrackQRShowParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'hover',
    label,
    products: [{ id: offerId, offerType: 'promo' }],
  });
};

interface ICallButtonClickParams {
  action: 'Open_carousel_promo' | 'Open_detail_promo';
  customUrl?: string | null;
  id?: number | null;
  extra?: { promoId: string | null; is_price_with_discount?: boolean };
}

export const trackCallButtonClick = ({ action, customUrl, id, extra }: ICallButtonClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action,
    label: customUrl || '',
    products: [{ ...(id ? { id } : {}), extra }],
  });
};
